import React from 'react';
import {TranslationIssue} from './translation-issue';

const CustomBeforeSection = () => {
  return <>
    <TranslationIssue />
  </>
};

export default CustomBeforeSection;
